import React from 'react'
import { Button } from 'views/components'
import styles from './SuspensePagination.module.scss'

interface SuspensePaginationProps {
  /** 1-based */
  page: number
  /** 0 when nothing matched */
  totalPages: number
  disabled?: boolean
  onPageChange: (page: number) => void
}

const SuspensePagination = ({
  page,
  totalPages,
  disabled = false,
  onPageChange,
}: SuspensePaginationProps): React.ReactElement | null => {
  if (totalPages <= 1) return null

  return (
    <div className={styles.root}>
      <Button size="sm" secondary disabled={disabled || page <= 1} onClick={() => onPageChange(page - 1)}>
        Previous
      </Button>
      <span>
        Page {page} of {totalPages}
      </span>
      <Button size="sm" secondary disabled={disabled || page >= totalPages} onClick={() => onPageChange(page + 1)}>
        Next
      </Button>
    </div>
  )
}

export default SuspensePagination
